export type ClientDashboardMode = "buyer" | "seller";

const CLIENT_DASHBOARD_MODE_KEY = "proptrust-client-dashboard-mode";

export function isClientDashboardMode(value: unknown): value is ClientDashboardMode {
  return value === "buyer" || value === "seller";
}

export function getClientDashboardModeStorageKey(userId?: string | null) {
  return userId ? `${CLIENT_DASHBOARD_MODE_KEY}:${userId}` : CLIENT_DASHBOARD_MODE_KEY;
}

export function readStoredClientDashboardMode(userId?: string | null) {
  if (typeof window === "undefined") {
    return undefined;
  }

  const storedValue = window.localStorage.getItem(getClientDashboardModeStorageKey(userId));
  return isClientDashboardMode(storedValue) ? storedValue : undefined;
}

export function persistClientDashboardMode(mode: ClientDashboardMode, userId?: string | null) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(getClientDashboardModeStorageKey(userId), mode);
}

export function resolveClientDashboardMode(modeCandidate?: unknown, userId?: string | null): ClientDashboardMode {
  if (isClientDashboardMode(modeCandidate)) {
    return modeCandidate;
  }

  const storedMode = readStoredClientDashboardMode(userId);
  return storedMode ?? "buyer";
}
